export default function tealium() {
  console.log("calling tealium fucntion")
  const env = process.env.HOST === 'https://learn.dropbox.com' ? '201131991534.min.js' : '336d83cf4d1d-staging.min.js';

  const uri = `https://assets.adobedtm.com/7c31e7b46b8e/1c0a7efc18cb/launch-${env}`;
  const script = document.createElement('script');
  script.src = uri;
  script.type = 'text/javascript';
  script.async = true;
  document.body.appendChild(script);
}